// extracted by mini-css-extract-plugin
module.exports = {"toggleAuthContainer":"ToggleAuth_toggleAuthContainer__0Kdca","toggleButton":"ToggleAuth_toggleButton__mXzTH","active":"ToggleAuth_active__H4FDW"};